import { Amplify } from 'aws-amplify';

// Dev-mode bypass mirrors useAuth — skip Amplify configuration when running
// with VITE_DEV_AUTH=1 (otherwise Amplify throws on undefined Cognito IDs).
const DEV_AUTH_BYPASS =
  import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === '1';

export function configureAmplify() {
  if (DEV_AUTH_BYPASS) return;

  const userPoolId = import.meta.env.VITE_ADMIN_COGNITO_USER_POOL_ID as string;
  const userPoolClientId = import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID as string;
  const domain = import.meta.env.VITE_ADMIN_COGNITO_DOMAIN as string;

  if (!userPoolId || !userPoolClientId || !domain) {
    // Skip Amplify configuration if env not set; sign-in will be unusable
    // but the rest of the app loads (helpful for surfacing the misconfig
    // rather than crashing on app boot).
    // eslint-disable-next-line no-console
    console.warn('Cognito config missing — sign-in disabled. Set VITE_ADMIN_COGNITO_* env vars.');
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code'
          }
        }
      }
    }
  });
}
